import { FLAG_DEMOGRAPHICS_INCORRECT_GUARANTOR } from 'src/store/actions/types';
import appService from 'src/pl.service';
import { statuses } from 'src/constants/statuses';

/**
 * commits the id to the store using the GET_GUARANTOR action type
 */
 export const flagDemographicsIncorrectGuarantor = async ({ commit, state }, {demographicId, checked}) => {
  try{
    await appService.flagDemographicsAsIncorrect(demographicId ?? state.guarantor.demographic.demographicId, checked);
    commit(
      FLAG_DEMOGRAPHICS_INCORRECT_GUARANTOR,
      {
          status: statuses.success,
          checked: checked,
        }
      );
    } catch (error) {
  commit(FLAG_DEMOGRAPHICS_INCORRECT_GUARANTOR, {
    status: statuses.failure,
    error,
  });    
}
};